"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startsWithMatcherContext = void 0;
var lang_1 = require("../../utils/lang");
function startsWithMatcherContext(ruleAttr) {
    return function startsWithMatcher(runtimeAttr) {
        var matches = ruleAttr.some(function (e) { return (0, lang_1.startsWith)(runtimeAttr, e); });
        return matches;
    };
}
exports.startsWithMatcherContext = startsWithMatcherContext;
